<template>
 
   <v-layout align-start>
    <v-flex>
        <v-toolbar text color="white">


          <v-toolbar-title >Maestra Indicadores</v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" v-if="verNuevo==0"  v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="1200px">
                <v-spacer></v-spacer>

                    <template v-slot:activator="{ on }">
                        <v-btn  @click="mostrarNuevo" color="primary" dark class="mb-3" v-on="on">Nueva Definición Indicador</v-btn>
                    </template>

                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-row>

                                        <v-col cols="12" sm="6" md="8">
                                            <v-select v-model="id_objetivo"
                                                :items="nombre_objetivo"  label="Objetivo">
                                            </v-select>
                                        </v-col>                                        
                                        <v-col cols="12" sm="6" md="8">
                                            <v-text-field v-model="codigo_indicador" label="Codigo Indicador"></v-text-field>
                                        </v-col>                            

                                        <v-col cols="12" sm="6" md="8">
                                            <v-text-field v-model="nombre_indicador" label="Nombre Indicador"></v-text-field>
                                        </v-col>                            

                                        <v-col cols="12" sm="6" md="12">
                                            <v-text-field v-model="descripcion_indicador" label="Descripción"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="12">
                                            <v-text-field v-model="frecuencia_indicador" label="Frecuencia"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="8">
                                            <v-select v-model="codigo_responsable_indicador"
                                                :items="nombre_responsable_indicador"  label="Responsable Area">
                                            </v-select>
                                        </v-col>                                        
                                        <v-col cols="12" sm="6" md="12">
                                            <v-text-field type="number" v-model="peso_indicador" label="Peso %"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="12">
                                            <v-text-field v-model="alcance_indicador" label="Alcance"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="12">
                                            <v-text-field v-model="unidad_medida_indicador" label="Unidad Medida"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="12">
                                            <v-text-field v-model="que_mide_el_indicador" label="Que Mide"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="12">
                                            <v-text-field v-model="tipo_indicador" label="Tipo Indicador"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="6" md="12">
                                            <v-text-field v-model="formula_indicador" label="Formula Indicador"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="fuente_informacion_indicador" label="Fuente Informacion"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="tendencia_indicador" label="Tendencia"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                            <v-text-field type="number" v-model="meta_indicador" label="Meta"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                            <v-text-field type="number" v-model="inicio_indicador" label="Inicio"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                            <v-text-field type="number" v-model="minimo_indicador" label="Minimo"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                            <v-text-field type="number" v-model="limite_inferior_indicador" label="Limite Inferior"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                            <v-text-field type="number" v-model="limite_superior_indicador" label="Limite Superior"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                            <v-text-field type="number" v-model="maximo_indicador" label="Maximo"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="8">
                                            <v-select v-model="codigo_area_responsable_indicador"
                                                :items="nombre_responsable_indicador"  label="Responsable Indicador">
                                            </v-select>
                                        </v-col>                                        
                                    </v-row>
                                    <v-flex xs12 sm12 md12 v-show="valida">
                                        <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">
                                        </div>
                                    </v-flex>

                                </v-layout>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click.native="close">Cancelar</v-btn>
                            <v-btn color="red darken-1" text @click.native="guardar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>cd
                </v-dialog>


                 <v-dialog v-model="adModal" max-width="290">
                    <v-card>
                        <v-card-title class="headline" v-if="adAccion==1">¿Activar Item? </v-card-title>
                        <v-card-title class="headline" v-if="adAccion==2">¿Desactivar Item? </v-card-title>
                    <v-card-text>
                        Estas a punto del
                        <span v-if="adAccion==1">Activar </span>
                        <span v-if="adAccion==2">Desactivar </span>
                        el item {{ adIdMaestroIndicador}}    
                    </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" text="text" @click="activarDesactivarCerrar">
                                    Cancelar
                                </v-btn>
                                <v-btn v-if="adAccion==1" color="orange darken-4" text="text" @click="activar">
                                    Activar
                                </v-btn>
                                <v-btn v-if="adAccion==2" color="orange darken-4" text="text" @click="desactivar">
                                    Desactivar
                                </v-btn>
                            </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>

   <v-data-table
        :headers="headers"
        :items="maestra_indicadores"
        :search="search"
        class="elevation-1"
    >     
                <template v-slot:item.action="{ item }">
                    <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                    >
                        mdi-grease-pencil
                    </v-icon>
                    <template v-if="item.estado_indicador">
                        <v-icon
                            small
                            @click="activarDesactivarMostrar(2,item)"
                        >
                            mdi-block-helper
                        </v-icon>
                    </template>
                    <template v-else>
                        <v-icon
                            small
                            @click="activarDesactivarMostrar(1,item)"
                        >
                            mdi-check-all
                        </v-icon>
                    </template>
                </template>

                <template slot="items" slot-scope="props">
                    <td>{{ props.item.id_objetivo }}</td>
                    <td>{{ props.item.nombre_objetivo }}</td>
                    <td>{{ props.item.periodo }}</td>
                    <td>{{ props.item.codigo_indicador }}</td>
                    <td>{{ props.item.nombre_indicador }}</td>
                    <td>{{ props.item.descripcion_indicador }}</td>
                    <td>{{ props.item.frecuencia_indicador }}</td>
                    <td>{{ props.item.codigo_responsable_indicador }}</td>
                    <td>{{ props.item.nombre_responsable_gral_indicador }}</td>
                    <td>{{ props.item.peso_indicador }}</td>
                    <td>{{ props.item.alcance_indicador }}</td>
                    <td>{{ props.item.unidad_medida_indicador }}</td>
                    <td>{{ props.item.que_mide_el_indicador }}</td> 
                    <td>{{ props.item.tipo_indicador }}</td>
                    <td>{{ props.item.formula_indicador }}</td>
                    <td>{{ props.item.fuente_informacion_indicador }}</td>
                    <td>{{ props.item.tendencia_indicador }}</td>
                    <td>{{ props.item.meta_indicador }}</td> 
                    <td>{{ props.item.inicio_indicador }}</td>
                    <td>{{ props.item.minimo_indicador }}</td>
                    <td>{{ props.item.limite_inferior_indicador }}</td>
                    <td>{{ props.item.limite_superior_indicador }}</td>
                    <td>{{ props.item.maximo_indicador }}</td>
                    <td>{{ props.item.codigo_responsable_indicador }}</td>
                    <td>{{ props.item.nombre_responsable_indicador }}</td>
                    <td>
                        <div v-if="props.item.estado_indicador">
                            <span class="blue--text">Activo</span>
                        </div>
                        <div v-else>
                            <span class="red--text">Inactivo</span>
                        </div>
                    </td>
                </template>

                <template slot="no-data">
                <v-btn color="primary" @click="listar">Resetear</v-btn>
                </template>
    </v-data-table>

        </v-flex>
    </v-layout>

</template>

<script>
import axios from 'axios'

export default {
    data(){
        return{
                maestra_indicadores:[],                
                dialog: false,
                headers: [
                    { text: 'Opciones', value: 'action', sortable: false},
                    { text: 'Cod. Objetivo', value: 'id_objetivo' },
                    { text: 'Nombre Objetivo', value: 'nombre_objetivo' },
                    { text: 'Cod. Indicador', value: 'codigo_indicador' },
                    { text: 'Nombre Indicador', value: 'nombre_indicador' , sortable: false},                    
                    { text: 'Descripción', value: 'descripcion_indicador' , sortable: false},
                    { text: 'Frecuencia', value: 'frecuencia_indicador' , sortable: false},
                    { text: 'Responsable Gral', value: 'codigo_responsable_indicador' , sortable: false},
                    { text: 'Responsable General', value: 'nombre_responsable_gral_indicador' },
                    { text: 'Peso %', value: 'peso_indicador' , sortable: false},
                    { text: 'Alcance', value: 'alcance_indicador' , sortable: false},
                    { text: 'Unidad Medida', value: 'unidad_medida_indicador' , sortable: false},
                    { text: 'Que Mide', value: 'que_mide_el_indicador' , sortable: false},
                    { text: 'Tipo', value: 'tipo_indicador' , sortable: false},
                    { text: 'Formula', value: 'formula_indicador' },
                    { text: 'Fuente Infor.', value: 'fuente_informacion_indicador' },
                    { text: 'Tendencia', value: 'tendencia_indicador' },
                    { text: 'Meta', value: 'meta_indicador' },
                    { text: 'Valor Inicio', value: 'inicio_indicador' },
                    { text: 'Valor Minimo', value: 'minimo_indicador' },
                    { text: 'Limite Inferior', value: 'limite_inferior_indicador' },
                    { text: 'Limite Superior', value: 'limite_superior_indicador' },
                    { text: 'Valor Maximo', value: 'maximo_indicador' },
                    { text: 'Codigo Responsable Area', value: 'codigo_responsable_area_indicador' , sortable: false},
                    { text: 'Responsable Area', value: 'nombre_responsable_indicador' },
                    { text: 'Estado', value: 'estado_indicador' , sortable: false}
                ],
                search: '',
                editedIndex: -1,
                id_maestro_indicador : '',
                id_objetivo	: '',
                nombre_objetivo	:[
                ] ,
//                IdIndicador	: '',
                codigo_indicador	: '',
                nombre_indicador	: [
                ],
                descripcion_indicador	: '',
                frecuencia_indicador	: '',
                codigo_responsable_indicador	: '',
                nombre_responsable_gral_indicador:[                    
                ] ,
                peso_indicador	: '',
                alcance_indicador	: '',
                unidad_medida_indicador	: '',
                que_mide_el_indicador	: '',
                tipo_indicador:'',//['KPI','KRI', 'RI', 'PI'] ,
                formula_indicador	: '',
                fuente_informacion_indicador	: '',
                tendencia_indicador	: '',
                meta_indicador	: '',
                inicio_indicador	: '',
                minimo_indicador	: '',
                limite_inferior_indicador	: '',
                limite_superior_indicador	: '',
                maximo_indicador	: '',
                codigo_area_responsable_indicador	: '',
                nombre_responsable_indicador:[
                ] ,
                searchVarindi:'',
                codigo_responsable_indicador:'',
                indicador:[],
                texto:'',
                verindicadores:0,
                errorVariable:null,
                valida: 0,
                validaMensaje:[],
                adModal: 0,
                adAccion: 0,
                adIdMaestroIndicador:'',
                adNombre:''
        }
    },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Nuevo Maestro Indicador' : 'Actualizar Maestro Indicador'
            }
        },


    watch: {
        dialog (val) {
        val || this.close()
        },
    },

    created () {
        this.listar();
        this.select();
        this.selectObjetivo();
        this.selectIndicador();
    },
    methods:
    {
        mostrarNuevo(){
            this.verNuevo=1;
        },
        ocultarNuevo(){
            this.verNuevo=0;
            this.limpiar();
        },        

        listar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion= {headers : header};            
			axios.get('api/Indicadores/Listar',configuracion).then(function(response){
				//console.log(response);
				me.maestra_indicadores=response.data;
			}).catch(function(error){
				console.log(error);   
			});
		},
       
        listarIndicador(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion= {headers : header};            
			axios.get('api/Hechos_Variables_Indicador/ListarVariables/'+ me.texto, configuracion).then(function(response){
				//console.log(response);
				me.variables=response.data;
			}).catch(function(error){
				console.log(error);   
			});            
        },

        mostrarindicadores(){
            this.verindicadores =1;
        },
        ocultarindicadores(){
            this.verindicadores=0;
        },

       
            
        select(){
            let me=this;
            var responsableindicadorArray= [];
			axios.get('api/Responsables_Indicadores/Select').then(function(response){
                //console.log(response);
                responsableindicadorArray=response.data;
                responsableindicadorArray.map(function(x){
                    me.nombre_responsable_gral_indicador.push({text: x.nombre_responsable_indicador, value:x.codigo_responsable_indicador});
                });
			}).catch(function(error){
				console.log(error);   
			});
		},


        select(){
            let me=this;
            var responsableindicadorAreaArray= [];
			axios.get('api/Responsables_Indicadores/SelectArea').then(function(response){
                //console.log(response);
                responsableindicadorAreaArray=response.data;
                responsableindicadorAreaArray.map(function(x){
                    me.nombre_responsable_indicador.push({text: x.nombre_responsable_indicador, value:x.codigo_responsable_indicador});
                });
			}).catch(function(error){
				console.log(error);   
			});
		},

        selectObjetivo(){   
            let me=this;
            var objetivoindicadorArray= [];
			axios.get('api/Objetivos/Select').then(function(response){
                //console.log(response);
                objetivoindicadorArray=response.data;
                objetivoindicadorArray.map(function(x){
                    me.nombre_objetivo.push({text: x.nombre_objetivo, value:x.id_objetivo});
                });
			}).catch(function(error){
				console.log(error);   
			});
		},

        selectIndicador(){   
            let me=this;
            var indicadorArray= [];
			axios.get('api/Hechos_Variables_Indicador/SelectIndicador').then(function(response){
                //console.log(response);
                indicadorArray=response.data;
                indicadorArray.map(function(x){
                    me.nombre_indicador.push({text: x.nombre_indicador, value:x.codigo_indicador});
                });
			}).catch(function(error){
				console.log(error);   
			});
		},

		editItem (item) {
 			this.adIdMaestroIndicador=item.id_maestro_indicador;
            this.id_objetivo=item.id_objetivo;
//            this.IdIndicador=item.IdIndicador;
            this.codigo_indicador=item.codigo_indicador;
            this.descripcion_indicador=item.descripcion_indicador;
            this.frecuencia_indicador=item.frecuencia_indicador;
            this.codigo_responsable_indicador=item.codigo_responsable_indicador;
            this.peso_indicador=item.peso_indicador;
            this.alcance_indicador=item.alcance_indicador;
            this.unidad_medida_indicador=item.unidad_medida_indicador;
            this.que_mide_el_indicador=item.que_mide_el_indicador;
            this.tipo_indicador=item.tipo_indicador;
            this.formula_indicador=item.formula_indicador;
            this.fuente_informacion_indicador=item.fuente_informacion_indicador;
            this.tendencia_indicador=item.tendencia_indicador;
            this.meta_indicador=item.meta_indicador;
            this.inicio_indicador=item.inicio_indicador;
            this.minimo_indicador=item.minimo_indicador;
            this.limite_inferior_indicador=item.limite_inferior_indicador;
            this.limite_superior_indicador=item.limite_superior_indicador;
            this.maximo_indicador=item.maximo_indicador;
            this.codigo_area_responsable_indicador=item.codigo_area_responsable_indicador;
            this.estado_indicador=item.estado_indicador;
            this.editedIndex=1;            
			this.dialog = true
		},

		close () {
            this.dialog = false;
            this.limpiar();
		},

		limpiar(){
            this.id_maestro_indicador="";
            this.id_objetivo="";
            //this.IdIndicador="";
            this.codigo_indicador="";
            this.descripcion_indicador="";
            this.frecuencia_indicador="";
            this.codigo_responsable_indicador="";
            this.peso_indicador="";
            this.alcance_indicador="";
            this.unidad_medida_indicador="";
            this.que_mide_el_indicador="";
            this.tipo_indicador="";
            this.formula_indicador="";
            this.fuente_informacion_indicador="";
            this.tendencia_indicador="";
            this.meta_indicador="";
            this.inicio_indicador="";
            this.minimo_indicador="";
            this.limite_inferior_indicador="";
            this.limite_superior_indicador="";
            this.maximo_indicador="";
            this.codigo_area_responsable_indicador="";
            this.estado_indicador="";
			this.editedIndex=-1;
		},


		guardar () {
            
			if(this.validar()){
				return;
			}
			if (this.editedIndex > -1) {
				// codigo para guardar
				let me=this;
				axios.put('api/Indicadores/Actualizar',{
                    'idIndicador':me.idIndicador,
                    'id_objetivo':me.id_objetivo,
//                    'IdIndicador':me.IdIndicador,
                    'codigo_indicador':me.codigo_indicador,
                    'descripcion_indicador':me.descripcion_indicador,
                    'frecuencia_indicador':me.frecuencia_indicador,
                    'codigo_responsable_indicador':me.codigo_responsable_indicador,
                    'peso_indicador':me.peso_indicador,
                    'alcance_indicador':me.alcance_indicador,
                    'unidad_medida_indicador':me.unidad_medida_indicador,
                    'que_mide_el_indicador':me.que_mide_el_indicador,
                    'tipo_indicador':me.tipo_indicador,
                    'formula_indicador':me.formula_indicador,
                    'fuente_informacion_indicador':me.fuente_informacion_indicador,
                    'tendencia_indicador':me.tendencia_indicador,
                    'meta_indicador':me.meta_indicador,
                    'inicio_indicador':me.inicio_indicador,
                    'minimo_indicador':me.minimo_indicador,
                    'limite_inferior_indicador':me.limite_inferior_indicador,
                    'limite_superior_indicador':me.limite_superior_indicador,
                    'maximo_indicador':me.maximo_indicador,
                    'codigo_area_responsable_indicador':me.codigo_area_responsable_indicador
				}).then(function(response){
					me.close();
					me.listar();
					me.limpiar();                        
				}).catch(function(error){
					console.log(error);
				});

			} else {
		   //     this.desserts.push(this.editedItem)
				let me=this;
				axios.post('api/Indicadores/Crear',{
                    'id_objetivo':me.id_objetivo,
                    //'IdIndicador':me.IdIndicador,
                    'codigo_indicador':me.codigo_indicador,
                    'nombre_indicador':me.nombre_indicador,
                    'descripcion_indicador':me.descripcion_indicador,
                    'frecuencia_indicador':me.frecuencia_indicador,
                    'codigo_responsable_indicador':me.codigo_responsable_indicador,
                    'peso_indicador':me.peso_indicador,
                    'alcance_indicador':me.alcance_indicador,
                    'unidad_medida_indicador':me.unidad_medida_indicador,
                    'que_mide_el_indicador':me.que_mide_el_indicador,
                    'tipo_indicador':me.tipo_indicador,
                    'formula_indicador':me.formula_indicador,
                    'fuente_informacion_indicador':me.fuente_informacion_indicador,
                    'tendencia_indicador':me.tendencia_indicador,
                    'meta_indicador':me.meta_indicador,
                    'inicio_indicador':me.inicio_indicador,
                    'minimo_indicador':me.minimo_indicador,
                    'limite_inferior_indicador':me.limite_inferior_indicador,
                    'limite_superior_indicador':me.limite_superior_indicador,
                    'maximo_indicador':me.maximo_indicador,
                    'codigo_area_responsable_indicador':me.codigo_area_responsable_indicador
				}).then(function(response){
					me.close();
					me.listar();
					me.limpiar();                        
				}).catch(function(error){
					console.log(error);
                });
                
			}
        },

		validar(){
			this.valida=0;
			this.validaMensaje=[];
     
			if(this.nombre_indicador < 3 || this.nombre_indicador > 100){
				this.validaMensaje.push("El Nombre indicador debe tener mas de 3 caracteres y menos de 100 caracteres");
            }

			if(!this.peso_indicador){
				this.validaMensaje.push("Debe digitar el nombre de por lo menos una variable ");
            }
			if(!this.meta_indicador){
				this.validaMensaje.push("Debe digitar por lo menos una variable ");
            }
		    if(this.validaMensaje.length){
				this.valida=1;
			}
		    return this.valida;
        },

        activarDesactivarMostrar(accion,item){
        this.adModal=1;
//        this.adIdIndicador=item.idIndicador;
        if (accion==1){
            this.adAccion=1;
        }
        else if (accion==2){
        this.adAccion=2;
        }
        else{
        this.adModal=0;
        }
        },
        activarDesactivarCerrar(){
        this.adModal=0;
        },
        activar(){
            let me=this;
            axios.put('api/Hechos_Indicador/Activar/'+this.adIdIndicador,{}).then(function(response){
            me.adModal=0;
            me.adAccion=0;
            me.adNombre="";
            me.adIdIndicador="";
            me.listar();                       
            }).catch(function(error){
                console.log(error);
            });
        },
        desactivar(){
            let me=this;
            axios.put('api/Hechos_Indicador/Desactivar/'+this.adIdIndicador,{}).then(function(response){
                me.adModal=0;
                me.adAccion=0;
                me.adIdIndicador="";
                me.adNombre="";
                me.listar();                       
            }).catch(function(error){
            console.log(error);
        });
            }
        }        
    }
</script>